import { render } from "./NotAvailableView.vue?vue&type=template&id=227df39d&scoped=true&ts=true"
import script from "./NotAvailableView.vue?vue&type=script&lang=ts"
export * from "./NotAvailableView.vue?vue&type=script&lang=ts"

import "./NotAvailableView.vue?vue&type=style&index=0&id=227df39d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227df39d"]])

export default __exports__